import React, { useState } from 'react'

import { graphql, useStaticQuery } from 'gatsby'
import { FluidObject } from 'gatsby-image'
import firebase from 'gatsby-plugin-firebase'

import ButtonAppleStore from '~/assets/app_store.svg'
import ButtonGooglePlayMobile from '~/assets/google_play_mobile.svg'
// import ButtonGooglePlay from '~/assets/google_play.svg'
import FacebookFormDialog from '~/components/common/FacebookFormDialog'
import { Container } from '~/components/global'
import ButtonGooglePlay from '~/images/google_play.png'
import translate from '~/locale'

import {
  Flex,
  HeaderTextGroup,
  HeaderWrapper,
  ImageWrapper,
  InsideContainer,
  StoreButtons,
  StyledContainer,
  StyledImage,
} from './styles'

type Query = {
  mockup: {
    childImageSharp: {
      fluid: FluidObject
    }
  }
}

const Header: React.FC = () => {
  const data = useStaticQuery<Query>(graphql`
    query {
      mockup: file(
        sourceInstanceName: { eq: "product" }
        name: { eq: "mockup" }
      ) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const imgMockup = data.mockup.childImageSharp.fluid

  const [facebookFormDialogOpen, setFacebookFormDialogOpen] = useState<boolean>(
    false,
  )

  const handleDownloadClick = (store: string) => {
    firebase.analytics().logEvent('download', {
      store,
    })
    // setFacebookFormDialogOpen(true)
  }

  return (
    <>
      <HeaderWrapper id="top" />
      <InsideContainer>
        <Container>
          <Flex>
            <HeaderTextGroup>
              <h3>{translate('digitaldemocracy')}</h3>
              <h5>{translate('empowering_residents')}</h5>
              <div className="d-none d-md-block">
                <StoreButtons>
                  <div className="link-download">
                    <a
                      href="https://apps.apple.com/us/app/resident/id1547782698"
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => handleDownloadClick('apple')}
                    >
                      <ButtonAppleStore className="appleBtn" />
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=io.baseline.resident"
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => handleDownloadClick('google')}
                    >
                      <img src={ButtonGooglePlay} className="googleBtn" />
                    </a>
                    <FacebookFormDialog
                      open={facebookFormDialogOpen}
                      onClose={() => setFacebookFormDialogOpen(false)}
                    />
                  </div>
                </StoreButtons>
              </div>
            </HeaderTextGroup>
          </Flex>
          <svg className="svg">
            <clipPath id="hexagon-clip-path" clipPathUnits="objectBoundingBox">
              <path d="M0.316,0.986 L1,0.671 L1,0 L0,0 L0,0.748 L0.153,0.937 C0.199,0.996,0.254,1,0.316,0.986" />
            </clipPath>
          </svg>
          <svg className="svg">
            <clipPath
              id="mobile-hexagon-clip-path"
              clipPathUnits="objectBoundingBox"
            >
              <path d="M1,0.765 L0.356,0.972 C0.25,1,0.147,1,0.069,0.942 L0,0.886 L0,0 H1 L1,0.765" />
            </clipPath>
          </svg>
        </Container>
      </InsideContainer>
      <StyledContainer>
        <ImageWrapper>
          <StyledImage fluid={imgMockup} />
          <br />
        </ImageWrapper>
        <div className="d-flex d-md-none justify-content-center mt-5 mt-sm-0">
          <StoreButtons>
            <div className="">
              <a
                href="https://apps.apple.com/us/app/resident/id1547782698"
                target="_blank"
                rel="noreferrer"
                onClick={() => handleDownloadClick('apple')}
              >
                <ButtonAppleStore height="42" className="appleBtn" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=io.baseline.resident"
                target="_blank"
                rel="noreferrer"
                onClick={() => handleDownloadClick('google')}
              >
                <ButtonGooglePlayMobile width="145" className="googleBtn" />
              </a>
            </div>
          </StoreButtons>
        </div>
      </StyledContainer>
    </>
  )
}

export default Header
